// Dark mode only — F-073 fix. Always enforce dark. No toggle.
export function useTheme() {
  // Always enforce dark class on html element
  if (typeof document !== 'undefined') {
    document.documentElement.classList.add('dark');
  }

  return { theme: 'dark' as const, setTheme: (_: string) => {} };
}